module.exports = __webpack_public_path__ + "static/mongodb-logo-96c5d02eab2ba1f9abea890e4ed073fd.png";